let PRIMARY_SERVER_URL = `${window.location.protocol}//${window.location.hostname}/api/`;
if (PRIMARY_SERVER_URL.includes("localhost")) {
    PRIMARY_SERVER_URL = process.env.REACT_APP_PRIMARY_SERVER_URL
}
let activeServerURL = PRIMARY_SERVER_URL


const token = localStorage.getItem("token");

/************************************************************************/


async function connectMemberToAPI(tcontextURL, tmethod, data, type) {
    try {
        const storedToken = token ?? localStorage.getItem("token");

        const headers = {
            "Content-Type": "application/json",
        };

        // ✅ Attach Authorization ONLY if token exists
        if (storedToken) {
            headers.Authorization = `Bearer ${storedToken}`;
        }

        const response = await fetch(activeServerURL + tcontextURL, {
            method: tmethod || "GET",
            headers,
            body: data ? JSON.stringify(data) : undefined,
        });

        console.log("STATUS:", response.status);

        if (response.status === 401) {
            localStorage.setItem("SError", "Session Timed out or Unauthorized Access");
            localStorage.removeItem("token");
            localStorage.removeItem("loggedMemberInfo");
            window.location.href = "/memberlogin";
            return;
        }

        return response;
    } catch (error) {
        console.error("Error connecting to API:", error);

        // if (activeServerURL === PRIMARY_SERVER_URL) {
        //   activeServerURL = SECONDARY_SERVER_URL;
        //   return connectMemberToAPI(tcontextURL, tmethod, data, type);
        // } else {
        //   activeServerURL = PRIMARY_SERVER_URL;
        //   return false;
        // }
    }
}

/************************************************************************/


export async function createMemberCart(bid, Update) {
    return await connectMemberToAPI(`memberportal/membercart/${bid}`, "POST", Update);
}

export async function getMemberCart(gymid, memberid) {
    return await connectMemberToAPI(`memberportal/membercart/${gymid}?memberid=${memberid}`, "GET");
}

export async function getMembersbyid(gymid, update) {
    return await connectMemberToAPI(`memberportal/membersbyid/${gymid}`, "POST", update);
}

export async function createMemberWidget(bid, Update) {
    return await connectMemberToAPI(`memberportal/memberwidget/${bid}`, "POST", Update);
}

export async function getMemberWidget(gymid, memberid) {
    return await connectMemberToAPI(`memberportal/memberwidget/${gymid}?memberid=${memberid}`, "GET");
}

export async function verifyNumber(updates) {
    return await connectMemberToAPI(`businessinfo/numberverify`, "POST", updates);
}

export async function getGBussinessInfo(bId) {
    return await connectMemberToAPI(`businessinfo/${bId}`)
}

export async function getMemberTransactions(mId) {
    return await connectMemberToAPI(`members/transactions/${mId}`);
}

export async function membersessions(bId) {
    return await connectMemberToAPI(`members/sessionProfile/${bId}`, "GET");
}

export async function memberByNumber(bId, updates, type) {
    return await connectMemberToAPI(`members/by-number/${bId}`, "POST", updates, type);
}

export async function createMembers(bid, membersdata) {
    return await connectMemberToAPI(`members/addmembers/${bid}`, "PUT", membersdata);
}

export async function randomTid() {
    return await connectMemberToAPI(`transaction/transcation/randomtid`, "GET")
}

export async function saveTransaction(updates, bId) {
    return await connectMemberToAPI(`transaction/${bId}`, "PUT", updates);
}

export async function uploadInvoice(updates, tId) {
    return await connectMemberToAPI(`transaction/upload/${tId}`, "POST", updates);
}

export async function checkMembershipDiscount(bId, update) {
    return await connectMemberToAPI(`class/checkmembership/${bId}`, "POST", update);
}

export async function getClassTransactionbyNumber(bId, tdata) {

    return await connectMemberToAPI(`class/transaction-by-number/${bId}`, "POST", tdata);
}

export async function getBussinessInfobyUrl(url, type) {
    return await connectMemberToAPI(`class/businessdetail/${url}?type=${type}`);
}
export async function downloadclassinvoice(update) {
    return await connectMemberToAPI(`class/downloadclassinvoice/${update.bid}`, "POST", update)
}

export async function getGymAddonsList(bId) {
    return await connectMemberToAPI(`addons/${bId}`);
}
export async function getGymPlansList(bId) {
    return await connectMemberToAPI(`plans/${bId}`);
}

export async function getUpcomingSessionbyMid(bId, tdata) {
    return await connectMemberToAPI(`class/upcomingsessions/${bId}`, "POST", tdata);
}


export async function getPlans(bId) {
    return await connectMemberToAPI(`plans/${bId}`);
}
export async function createAnnouncement(bid, Update) {
    return await connectMemberToAPI(`businessinfo/announcement/${bid}`, "POST", Update);
}

export async function getAnnouncements(gymid) {
    return await connectMemberToAPI(`businessinfo/announcement/${gymid}`, "GET");
}


export async function saveUser(updates, bId) {
    return await connectMemberToAPI(`members/${bId}`, "POST", updates);
}

export async function sendMemberwaiverUrl(updates) {

    return await connectMemberToAPI(`members/sendmemberwaiverurl/1234`, "POST", updates);
}

export async function getWaiverSettingsbyGymid(uid) {
    return await connectMemberToAPI(`waiver/Wsetting/gymid/${uid}`);
}

export async function getClassBookingWaiverSettings(gid) {
    return await connectMemberToAPI(`class/getclassbookwaiversettings/${gid}`);
}

export async function createWaiver(updates) {
    return await connectMemberToAPI(`waiver/waiver/0`, "POST", updates);
}
export async function createMultiWaiverForms(updates) {
    return await connectMemberToAPI(`waiver/createMultiWaiverForms`, "POST", updates);
}
export async function verifyWaiverOtp(updates) {
    return await connectMemberToAPI(`waiver/verify/otp`, "POST", updates);
}
export async function confirmWaiverVerifyLink(token, pid) {
    const q = `token=${encodeURIComponent(token || "")}&pid=${encodeURIComponent(pid || "")}`;
    return await connectMemberToAPI(`waiver/verify/link?${q}`, "GET");
}
export async function resendWaiverVerification(updates) {
    return await connectMemberToAPI(`waiver/verify/resend`, "POST", updates);
}
export async function logEvent(data, gymId) {
    return await connectMemberToAPI(`logEvent/${gymId}`, "POST", data);
}
export async function getPricingPlansById(uid) {
    return await connectMemberToAPI(`pricingplan/planbyid/${uid}`);
}

export async function getMemeberProfile(mId) {
    return await connectMemberToAPI(`members/profile/${mId}`);
}

export async function getClassBookingInfo(bId) {
    return await connectMemberToAPI(`class/classbooking/${bId}`);
}

export async function getMembersBySchedule(id, updates) {
    return await connectMemberToAPI(`class/getmembersbyschedule/${id}`, "POST", updates);
}

export async function getScheduleById(id) {
    return await connectMemberToAPI(`class/schedulebyid/${id}`);
}


export async function getMembersBySchedulewithplans(id, updates) {
    return await connectMemberToAPI(`class/getMembersBySchedulewithplans/${id}`, "POST", updates);
}
